import { makeStyles } from '@mui/styles';
import { GridColDef, GridToolbarContainer } from '@mui/x-data-grid';
import React from 'react';

import ButtonComponent from '#app/Component/ButtonComponent';
import DataGrid from '#app/Component/DataGrid';
import IconAction from '#app/Component/IconAction';
import { Filters } from '#app/View/InventoryManagement/Deposit/Picking';
import ActionRemove from '#app/View/InventoryManagement/Deposit/Picking/components/ActionRemove';
import { useCollectionPaginated } from '#app/hooks/useCollectionPaginated';
import { DepositByProductPicking } from '#app/typings/depositByProduct';

type Props = Omit<
  ReturnType<typeof useCollectionPaginated<DepositByProductPicking, Filters>>,
  'filters' | 'setFilters'
> & {
  onEdit: (item?: DepositByProductPicking) => void;
};

const List: React.FC<Props> = ({
  data: depositByProduct,
  totalItems,
  loading,
  pagination,
  sorting,
  setPagination,
  setSorting,
  onEdit,
  mutate,
}) => {
  const classes = useStyles();

  const columns: GridColDef[] = [
    {
      field: 'sku',
      headerName: 'SKU',
      flex: 1,
    },
    {
      field: 'mark',
      headerName: 'Marque',
      flex: 1,
    },
    {
      field: 'product',
      headerName: 'Nom du produit',
      flex: 1,
    },
    {
      field: 'packSize',
      headerName: 'Conditionnement',
      flex: 1,
    },
    {
      field: 'flavor',
      headerName: 'Parfum',
      flex: 1,
    },
    {
      field: 'pickingLocation',
      headerName: 'Picking',
      flex: 1,
    },
    {
      field: 'action',
      headerName: 'Action',
      type: 'actions',
      width: 100,
      getActions: ({ row }) => [
        <ActionRemove mutate={mutate} id={row.id} />,
        <IconAction title="Editer" icon="edit" onClick={() => onEdit(row)} />,
      ],
    },
  ];

  return (
    <DataGrid
      className={classes.container}
      rows={depositByProduct}
      columns={columns}
      loading={loading}
      rowCount={totalItems}
      pagination={pagination}
      setPagination={setPagination}
      sorting={sorting}
      setSorting={setSorting}
      slots={{
        toolbar: () => (
          <GridToolbarContainer sx={{ justifyContent: 'flex-end' }}>
            <ButtonComponent color="#388E3C" label="Ajouter un produit" onClick={() => onEdit()} />
          </GridToolbarContainer>
        ),
      }}
    />
  );
};

const useStyles = makeStyles({
  container: {
    marginTop: 15,
  },
});

export default List;
